<!-- 专业合作社 -->
<template>
<div class="site-content">
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col col-per-70">
        <infoPageList-02 title="专业合作社" label="INFORMARION" :showTitle="true" :showSearch="true" :showMore="false" :infoPage="infoPage1" :infoBlock="infoBlock1" count="8" v-on:queryPage="zyhzs_Req"/>
      </div>
      <div class="content-col col-per-30">
        <infoList title="推荐合作社" label="THE COOPERATIVE" :showTitle="true" :showMore="false" :infoBlock="infoBlock2" :infoPage="infoPage2" v-on:queryPage="tjhzs_Req" titleLength="30" count="3"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoPageList02 from '../block/InfoPageList02'
import ZyhzsInfo1 from '../module/ZyhzsInfo1'
import ZyhzsInfo2 from '../module/ZyhzsInfo2'
import InfoList from '../block/InfoList'
export default {
  name: 'Zyhzs01',
  components: {
    'infoPageList-02': InfoPageList02,
    'infoList':InfoList,
  },
  data() {
    return {
      msg: '',
      infoBlock1:ZyhzsInfo1,
      infoBlock2:ZyhzsInfo2,
      infoPage1:{},
      infoPage2:{}
    }
  },
  methods:{
    //专业合作社
    zyhzs_Req(params){
          let that=this;
          let result={page:params};
          console.log('父页面查询参数：'+JSON.stringify(params));
          that.$dataApi.orchardLists(params).then(res =>{
          //console.log('请求Vue-axios结果：'+JSON.stringify(res))
          that.msg=res.msg;
          result.list= res.data.list;
          result.page.total=res.data.list.length;
          that.infoPage1=result;
          //console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
    },
    //推荐合作社
    tjhzs_Req(params){
          let that=this;
          let result={page:params};
          console.log('父页面查询参数：'+JSON.stringify(params));
          that.$dataApi.orchardLists(params).then(res =>{
          //console.log('请求Vue-axios结果：'+JSON.stringify(res))
          that.msg=res.msg;
          result.list= res.data.list;
          result.page.total=res.data.total;
          that.infoPage2=result;
          console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow:3;
}

.col-per-30 {
  flex-grow:1;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Zyhzs01.vue